export const SERIES_LABEL = 'seriesLabel';
